import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimburtTravelPlaceApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimburtTravelPlace'
  }

}